import {
  SET_SELECTED_ROLES,
  LOAD_SELECTED_ROLES_FROM_STORAGE,
} from "../reducers/SelectedRolesReducer";
import { notifyParentOfSelectedRoles } from "../../../handler/ParentDataHandler";

/**
 * Action to load selected roles from localStorage
 */
export function loadSelectedRolesFromStorage() {
  return {
    type: LOAD_SELECTED_ROLES_FROM_STORAGE,
  };
}

/**
 * Thunk to update selected roles with validation
 * @param {string[]} roles - Array of selected role values
 */
export function updateSelectedRoles(roles) {
  return (dispatch) => {
    // Ensure roles is an array
    const rolesArray = Array.isArray(roles) ? roles : [roles];

    // Dispatch the action to update roles
    dispatch({
      type: SET_SELECTED_ROLES,
      payload: rolesArray,
    });

    // Notify parent window of role changes
    notifyParentOfSelectedRoles(rolesArray);
  };
}



// WEBPACK FOOTER //
// ./src/components/mySCC/common/thunks/SelectedRolesDispatcher.js